import React from 'react'
import { PortalNav } from '@ctsu/nav-spine'
import { Notification } from '@ctsu/react-ctsu-ui'
import { getToken, withAppContext, usePermission } from '@ctsu/loader'
import CTSUErrorBoundary from 'components/ErrorBoundary'

function Home({ context }) {
  const { session } = context
  const callbackFun = () => {
    // This is added for demo
  }

  return (
    <div className="row">
      <CTSUErrorBoundary>
        <PortalNav
          appRoot={`${process.env.REACT_APP_ORIGIN}`}
          getToken={getToken}
          userContext={session}
          appName="PORTAL"
        />
      </CTSUErrorBoundary>
      <div className="portal-right col-9">
        <div className="row mb-2">
          <div className="content-page-title" style={{ fontSize: '2.25rem' }}>
            Welcome to Cancer Trials Support Unit
          </div>
        </div>
        <CTSUErrorBoundary>
          <Notification
            fnToken={getToken}
            notifAppName="ALL"
            appName={process.env.REACT_APP_NAME}
            userName={session.username}
            coreVersion={process.env.REACT_APP_CORE_API_VERSION}
            isMaintainer={usePermission('portal.notifications.edit')}
            appOrigin={`${process.env.REACT_APP_ORIGIN}core-service/`}
            notifDismisCbFn={callbackFun}
          />
        </CTSUErrorBoundary>
      </div>
    </div>
  )
}

export default withAppContext(Home)
